/**
 * Clipping Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.8.25
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ClientAnalyticsFilterRequest {
    startDate: string;
    endDate: string;
    compareStartDate?: string;
    compareEndDate?: string;
    tagIds?: Array<string>;
    mediaTypes?: Array<string>;
    mediaOutlets?: Array<string>;
    authors?: Array<string>;
    sentiments?: Array<string>;
    sourceTypes?: Array<string>;
    topics?: Array<string>;
}
